export const Logo = ({ className = "h-14" }) => (
  <img
    src="/voltcore-logo.png"
    alt="VoltCore Elektro – Elektrovorbereitung & Kernbohrungen"
    className={`w-auto ${className}`}
    data-testid="voltcore-logo"
  />
);
